let configuredMeasurementId

function measurementId() {
  return document.querySelector('meta[name="google-analytics-measurement-id"]')?.content
}

function ensureGtag() {
  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function() {
    window.dataLayer.push(arguments)
  }
}

function trackPageView() {
  const id = measurementId()
  if (!id) return

  ensureGtag()

  if (configuredMeasurementId !== id) {
    window.gtag("js", new Date())
    window.gtag("config", id, { send_page_view: false })
    configuredMeasurementId = id
  }

  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_title: document.title
  })
}

document.addEventListener("turbo:load", trackPageView)
